// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1tOod","title":"Info_title__1QVQZ","selects":"Info_selects__1S9he","requiredAsterisk":"Info_requiredAsterisk__1Uzi6"};